import { sendTransferAcceptRequest, sendTransferRejectRequest } from '../api/transfers';

export const canRespondToOffer = (offer, teamId) =>
  Boolean(
    offer?._id &&
      teamId &&
      offer.sending_team?._id === teamId &&
      [0, 1].includes(offer.category) &&
      offer.status === 0 &&
      offer.type !== 2
  );

const acceptErrors = {
  201: 'Player no longer exists.',
  202: 'Player is already in that team.',
  203: 'Player is on loan.',
  204: 'Not enough cash.',
  205: 'Another offer already exists.',
  206: 'Player is no longer in the team.',
  207: 'You cannot act on this offer.',
  208: 'Offer is no longer open.',
  209: 'The buyer’s roster is full.',
  210: 'Transfer window is closed.',
  211: 'Transfer window is closed.',
  212: 'One of the teams is playing a match.',
};
const rejectErrors = {
  201: 'You cannot act on this offer.',
  202: 'Offer is no longer open.',
  211: 'Transfer window is closed.',
};

// The API uses 200 for success and other 2xx codes for business errors.
// Never retry a POST automatically: a lost response may still mean it succeeded.
export async function respondToOffers(offers, action, onProgress = () => {}) {
  if (!['accept', 'reject'].includes(action)) throw new Error('Unknown transfer action');
  const request =
    action === 'accept' ? sendTransferAcceptRequest : sendTransferRejectRequest;
  const errors = action === 'accept' ? acceptErrors : rejectErrors;
  const results = [];
  for (const offer of offers) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await request(offer._id, controller.signal);
      results.push({
        id: offer._id,
        name: offer.player?.name || 'Player',
        success: response.status === 200,
        message:
          response.status === 200
            ? action === 'accept'
              ? 'Accepted'
              : 'Rejected'
            : errors[response.status] ||
              `Request failed (${response.status}). Refresh deals before trying again.`,
      });
    } catch {
      results.push({
        id: offer._id,
        name: offer.player?.name || 'Player',
        success: false,
        message: 'Could not confirm the result. Refresh deals before trying again.',
      });
    } finally {
      clearTimeout(timeout);
    }
    onProgress(results.length);
  }
  return results;
}
